import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import InfoOutlined from '@mui/icons-material/InfoOutlined';

// Banner shows for 24 hours: set to end of day when you deploy (e.g. deploy Feb 24 → set Feb 25 23:59)
const BANNER_EXPIRES_AT_MS = new Date('2026-02-25T23:59:59Z').getTime();

const STORAGE_KEY_DISMISSED = 'appUpdateBannerDismissed_ios140';

const AppUpdateBanner: React.FC = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const now = Date.now();
    const expired = now >= BANNER_EXPIRES_AT_MS;
    const dismissed = sessionStorage.getItem(STORAGE_KEY_DISMISSED) === 'true';

    if (!expired && !dismissed) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, []);

  const handleClose = () => {
    sessionStorage.setItem(STORAGE_KEY_DISMISSED, 'true');
    setOpen(false);
  };

  if (!open) return null;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      sx={{ zIndex: 9999 }}
      BackdropProps={{ sx: { backgroundColor: 'rgba(0,0,0,0.6)' } }}
      PaperProps={{
        sx: {
          borderRadius: 2,
          borderTop: '4px solid',
          borderColor: 'primary.main',
        },
      }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <InfoOutlined color="primary" />
        App update
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" paragraph>
          A new version of the app will be available soon — it&apos;s pending expedited review.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Please ensure you are on version <strong>iOS 1.4.0</strong> when it&apos;s released.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} variant="contained" color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AppUpdateBanner;
